import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as IlusIcon } from "../inlineSvgs/ilus-done.svg";
import { useDispatch } from "react-redux";
import { clearOrder } from "../store/slice/orderSlice";

const CreateSuccessPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearOrder());
  }, []);

  return (
    <div className="successPage successBooking">
      <div className="wrapper">
        <IlusIcon />
        <div className="title">Booking Successfully!</div>
        <div className="sub-title">
          Your booking is confirmed! Get ready to enjoy our services. Are waiting for you!
        </div>
        <div className="button-section">
          <Link to="/" className="beauty-btn fill">
            Go to Homepage
          </Link>
          <Link to="/orders" className="beauty-btn border">
            Your Bookings
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CreateSuccessPage;
